import QRCode from 'react-qr-code';

interface EmployeeQrCard {
  id: number;
  first_name: string;
  last_name: string;
  username: string;
  qr_code_token: string;
}

interface EmployeeQrBusinessCardsPrintProps {
  employees: EmployeeQrCard[];
}

export const EmployeeQrBusinessCardsPrint = ({
  employees,
}: EmployeeQrBusinessCardsPrintProps) => {
  return (
    <div>
      {employees.map((employee) => (
        <div
          key={employee.id}
          className="keep-together"
          style={{
            display: 'inline-block',
            verticalAlign: 'top',
            width: '85mm',
            height: '55mm',
            margin: '2mm',
            padding: '4mm',
            border: '1px solid #ccc',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8mm',
              height: '100%',
            }}
          >
            <QRCode
              size={256}
              value={employee.qr_code_token}
              style={{
                width: '32mm',
                height: '32mm',
                flexShrink: 0,
              }}
            />
            <div style={{ minWidth: 0 }}>
              <p
                style={{
                  margin: 0,
                  fontWeight: 600,
                  fontSize: '13pt',
                  wordBreak: 'break-word',
                }}
              >
                {employee.first_name} {employee.last_name}
              </p>
              <p
                style={{
                  margin: '1.5mm 0 0',
                  fontSize: '12pt',
                }}
              >
                #{employee.id}
              </p>
              <p
                style={{
                  margin: '1.5mm 0 0',
                  fontSize: '10pt',
                  color: '#555',
                  wordBreak: 'break-word',
                }}
              >
                {employee.username}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
